import React from 'react';
import { useUser } from './UserContext';

export function withUser<Props>(Component: any) {
  return (props: Props) => {
    const user = useUser();
    return <Component {...(props as Props)} {...user} />;
  };
}
